'use strict';

import React from 'react';

import StatusBar from  'components/base/StatusBar';
import ConditionalDisplay from 'components/utils/ConditionalDisplay';
import appConstants from 'constants/appConstants';
import _ from 'underscore';
import moment from 'moment';


class LeaveApplyOverlappedLeave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            overlappedLeaveMessage: null,
        };
    }

    getStartDateHour(startDate, startSession) {
        let appStartDate = moment(startDate);
        if (startSession === appConstants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.VALUE)
            appStartDate = appStartDate.add(12, 'hours');
        
        return appStartDate;
    }

    getEndDateHour(endDate, endSession, startDate, workingDays) {
        const appStartDate = moment(startDate);
        let appEndDate = moment(endDate);
              
        if (endSession === appConstants.ENUMS.LEAVE_HALFDAY_SESSIONS.FIRST_HALF.VALUE)
            appEndDate = appEndDate.add(11, 'hours');                
        else if (endSession === appConstants.ENUMS.LEAVE_HALFDAY_SESSIONS.SECOND_HALF.VALUE)
            appEndDate = appEndDate.add(23, 'hours');
        else if (moment.duration(appStartDate.diff(appEndDate)).asDays() === workingDays)
            appEndDate = appEndDate.add(23, 'hours');        
        else 
            appEndDate = appEndDate.add(11, 'hours');

        return appEndDate;
    }

    componentWillUpdate(nextProps) {        
        if ((!this.props.leaveApplications && nextProps.leaveApplications) || this.props.startDate !== nextProps.startDate || this.props.endDate !== nextProps.endDate 
                || this.props.startSession !== nextProps.startSession || this.props.endSession !== nextProps.endSession) {
                            
            const overlappedLeave = _.find(nextProps.leaveApplications, function (app) {
                if (!nextProps.application || (nextProps.application && nextProps.application.Id !== app.Id)) {
                    if (!app.Deleted &&
                        app.LeaveStatusLabel !== appConstants.ENUMS.LEAVE_STATUS_LABELS.CANCELLED &&
                        (app.LeaveStatus === appConstants.ENUMS.LEAVE_STATUS.PENDING ||
                        app.LeaveStatus === appConstants.ENUMS.LEAVE_STATUS.APPROVED ||
                        app.LeaveStatus === appConstants.ENUMS.LEAVE_STATUS.IN_APPROVAL)
                    ) {                        
                        const appStartDate = this.getStartDateHour(app.StartDate, app.StartSession);
                        const appEndDate = this.getEndDateHour(app.EndDate, app.EndSession);

                        const newStartDate = this.getStartDateHour(nextProps.startDate, nextProps.startSession);
                        const newEndDate = this.getEndDateHour(nextProps.endDate, nextProps.endSession);
                    
                        return (
                            newStartDate.isSameOrAfter(appStartDate) &&
                            newStartDate.isSameOrBefore(appEndDate)
                        ) || (
                            newEndDate.isSameOrAfter(appStartDate) &&
                            newEndDate.isSameOrBefore(appEndDate)
                        ) || (
                            newStartDate.isSameOrBefore(appStartDate) &&
                            newEndDate.isSameOrAfter(appEndDate)
                        );
                    }
                }
            }.bind(this));

            if (overlappedLeave) {
                if (overlappedLeave.LeaveStatus === appConstants.ENUMS.LEAVE_STATUS.PENDING || overlappedLeave.LeaveStatus === appConstants.ENUMS.LEAVE_STATUS.IN_APPROVAL) {
                    this.setState({
                        overlappedLeaveMessage: "You already have leave submitted for this period",
                    });
                    this.props.onOverlappedLeaveChange(true);
                } else if (overlappedLeave.LeaveStatus === appConstants.ENUMS.LEAVE_STATUS.APPROVED) {
                    this.setState({
                        overlappedLeaveMessage: "You already have leave approved for this period",
                    });
                    this.props.onOverlappedLeaveChange(true);
                } else {
                    this.setState({
                        overlappedLeaveMessage: null,
                    });
                    this.props.onOverlappedLeaveChange(false);
                }
            } else {
                this.setState({
                    overlappedLeaveMessage: null,
                });
                this.props.onOverlappedLeaveChange(false);
            }
        }
    }


    render() {
        if (this.props.forecastingError) {
            return null;
        }

        return (
            <ConditionalDisplay test={this.state.overlappedLeaveMessage !== null} className="overlapped-leave-msg">
                <StatusBar
                    warning={!this.props.showError ? true : undefined}
                    error={this.props.showError ? true : undefined}
                    content={this.state.overlappedLeaveMessage}
                />
            </ConditionalDisplay>
        );
    }
}

export default LeaveApplyOverlappedLeave; 
